@file:OptIn(InternalResourceApi::class)

package ifaandroid.feature.tasks.tasks_ui_common.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/ifaandroid.feature.tasks.tasks_ui_common.generated.resources/"

@delegate:ResourceContentHash(218_863_635)
internal val Res.drawable.ic_bottle: DrawableResource by lazy {
      DrawableResource("drawable:ic_bottle", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_bottle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_045_618_370)
internal val Res.drawable.ic_checkmark_rounded_40: DrawableResource by lazy {
      DrawableResource("drawable:ic_checkmark_rounded_40", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_checkmark_rounded_40.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_735_952_161)
internal val Res.drawable.ic_checkmark_rounded_dark_40: DrawableResource by lazy {
      DrawableResource("drawable:ic_checkmark_rounded_dark_40", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_checkmark_rounded_dark_40.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_209_305_212)
internal val Res.drawable.ic_meditation_20: DrawableResource by lazy {
      DrawableResource("drawable:ic_meditation_20", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_meditation_20.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(728_952_755)
internal val Res.drawable.ic_pizza: DrawableResource by lazy {
      DrawableResource("drawable:ic_pizza", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_pizza.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_bottle", Res.drawable.ic_bottle)
  map.put("ic_checkmark_rounded_40", Res.drawable.ic_checkmark_rounded_40)
  map.put("ic_checkmark_rounded_dark_40", Res.drawable.ic_checkmark_rounded_dark_40)
  map.put("ic_meditation_20", Res.drawable.ic_meditation_20)
  map.put("ic_pizza", Res.drawable.ic_pizza)
}
